exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".money__priceWrapper___3odTB {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%; }\n  @media (max-width: 768px) {\n    .money__priceWrapper___3odTB {\n      flex-direction: column;\n      gap: 8px; } }\n\n.money__priceInput___2fhzS {\n  width: calc(50% - 8px);\n  flex-shrink: 0; }\n  .money__priceInput___2fhzS:only-child {\n    width: 100%; }\n  @media (max-width: 768px) {\n    .money__priceInput___2fhzS {\n      width: 100%; } }\n", ""]);

// exports
exports.locals = {
	"priceWrapper": "money__priceWrapper___3odTB",
	"priceInput": "money__priceInput___2fhzS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/Money/money.scss
// module id = 2269
// module chunks = 6